<template>
  <v-container class="progress-status-journey">
    <v-row>
      <v-col cols="12" lg="5">
        <v-row class="border ma-2">
          <v-col>
            <v-row align="center">
              <!-- Header -->
              <v-col cols="4">
                <h3 class="text-wrap">
                  {{ $ucfirst($t("journeyProgress.yourJourney")) }}
                </h3>
              </v-col>
              <!-- Slider -->
              <v-col cols="8">
                <div class="d-flex align-center" @click="onSliderClick">
                  <h5
                    class="pr-2 progress-status-journey__slider-label"
                    :style="{ color: $color.coro['gray']}"
                  >
                    {{ $ucfirst($t("alerts.time")) + " " }}
                    {{ selectedWeekSlider }}
                  </h5>
                  <v-slider
                    min="0"
                    :max="journeyProgress != null
                      ? Object.keys(journeyProgress).length - 1
                      : 1
                    "
                    step="1"
                    v-model="sliderValue"
                    :thumb-label="false"
                    hide-details
                    :disabled="!isSliderAvailable"
                  >
                    <!-- <template v-slot:thumb-label="{ value }">
                      {{ journeyProgress[value].date }}
                    </template> -->
                  </v-slider>
                </div>
              </v-col>
            </v-row>
            <!-- Slider message -->
            <v-row v-if="isSliderAvailable">
              <v-col cols="12">
                <div class="border bg-color-coro-info-100 px-4 py-2">
                  <span style="font-size: 0.9rem">{{ $ucfirst($t('journeyProgress.useSlider')) }}</span>
                </div>
              </v-col>
            </v-row>
              <!-- Be healthy -->
              <v-row>
                <v-col
                  align="center"
                  class="col-12 py-0"
                >
                  <div
                    class="d-flex flex-column align-center py-3"
                    :style="{
                      backgroundColor: $color.coro['success-transparent-100'],
                    }"
                  >
                    <smart-icon
                        icon="mdi-heart-outline"
                        :iconColor="$color.coro['success-500']"
                    />
                    <h3
                        :style="{
                          color: $color.coro['success-500'],
                          textTransform: 'uppercase'
                        }"
                    >
                      {{
                        $t("journeyScreen.beHealthy", {
                          catalog: "app_mobile",
                        })
                      }}
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row style="height: 250px" class="align-items-end">
                <!-- Can't do it with v-for spacer don't seem to work then -->
                <v-spacer></v-spacer>
                <!-- Medication Adherence -->
                <v-col cols="auto" style="height: 250px">
                  <v-row
                      :style="{ height: heightPosition(1) + 'px' }"
                      class="mt-n3 your-journey__item"
                  >
                    <div class="your-journey__item-line">
                      <svg :height="heightPosition(1)" width="100%">
                        <defs>
                          <marker id="arrow" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="3" markerHeight="4" orient="270">
                            <path fill="#f0f0f0" d="M 0 0 L 10 5 L 0 10 z" />
                          </marker>
                        </defs>
                        <line
                          x1="24"
                          y1="16"
                          x2="24"
                          y2="250"
                          style="
                            stroke: #f0f0f0;
                            stroke-width: 6;
                            stroke-dasharray: 2, 4;
                          "
                          marker-start="url(#arrow)"
                        />
                      </svg>
                    </div>
                    <v-col
                        class="align-self-end"
                        :style="{
                        border: '1px solid ' + getColorPosition(1),
                        'background-color': getBackgroundColorPosition(1),
                        'border-radius': '16px !important',
                        'box-shadow':
                          '0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12) !important',
                        'z-index': '9999',
                        height: '50px',
                      }"
                        @click="setOverTimeChartDateFromJourney('MEDICATIONS')"
                    >
                      <smart-icon
                          icon="mdi-pill"
                          :iconColor="getColorPosition(1)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <!-- PA -->
                <v-col cols="auto" style="height: 250px">
                  <v-row
                      :style="{ height: heightPosition(0) + 'px' }"
                      class="mt-n3 your-journey__item"
                  >
                    <div class="your-journey__item-line">
                      <svg :height="heightPosition(0)" width="100%">
                        <defs>
                          <marker id="arrow" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="3" markerHeight="4" orient="270">
                            <path fill="#f0f0f0" d="M 0 0 L 10 5 L 0 10 z" />
                          </marker>
                        </defs>
                        <line
                          x1="24"
                          y1="16"
                          x2="24"
                          y2="250"
                          style="
                            stroke: #f0f0f0;
                            stroke-width: 6;
                            stroke-dasharray: 2, 4;
                          "
                          marker-start="url(#arrow)"
                        />
                      </svg>
                    </div>
                    <v-col
                        class="align-self-end"
                        :style="{
                        border: '1px solid ' + getColorPosition(0),
                        'background-color': getBackgroundColorPosition(0),
                        'border-radius': '16px !important',
                        'box-shadow':
                          '0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12) !important',
                        'z-index': '9999',
                        height: '50px',
                      }"
                        @click="setOverTimeChartDateFromJourney('STARTMOVING')"
                    >
                      <smart-icon
                          icon="mdi-run"
                          :iconColor="getColorPosition(0)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <!-- Healthy nutrition -->
                <v-col cols="auto" style="height: 250px">
                  <v-row
                      :style="{ height: heightPosition(3) + 'px' }"
                      class="mt-n3 your-journey__item"
                  >
                    <div class="your-journey__item-line">
                      <svg :height="heightPosition(3)" width="100%">
                        <defs>
                          <marker id="arrow" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="3" markerHeight="4" orient="270">
                            <path fill="#f0f0f0" d="M 0 0 L 10 5 L 0 10 z" />
                          </marker>
                        </defs>
                        <line
                          x1="24"
                          y1="16"
                          x2="24"
                          y2="250"
                          style="
                            stroke: #f0f0f0;
                            stroke-width: 6;
                            stroke-dasharray: 2, 4;
                          "
                          marker-start="url(#arrow)"
                        />
                      </svg>
                    </div>
                    <v-col
                        class="align-self-end"
                        :style="{
                        border: '1px solid ' + getColorPosition(3),
                        'background-color': getBackgroundColorPosition(3),
                        'border-radius': '16px !important',
                        'box-shadow':
                          '0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12) !important',
                        'z-index': '9999',
                        height: '50px',
                      }"
                        @click="
                        setOverTimeChartDateFromJourney('HEALTHYNUTRITION')
                      "
                    >
                      <smart-icon
                          icon="mdi-silverware-fork-knife"
                          :iconColor="getColorPosition(3)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <!-- Smoking cessation -->
                <v-col cols="auto" style="height: 250px">
                  <v-row
                      :style="{ height: heightPosition(2) + 'px' }"
                      class="mt-n3 your-journey__item"
                  >
                    <div class="your-journey__item-line">
                      <svg :height="heightPosition(2)" width="100%">
                        <defs>
                          <marker id="arrow" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="3" markerHeight="4" orient="270">
                            <path fill="#f0f0f0" d="M 0 0 L 10 5 L 0 10 z" />
                          </marker>
                        </defs>
                        <line
                          x1="24"
                          y1="16"
                          x2="24"
                          y2="250"
                          style="
                            stroke: #f0f0f0;
                            stroke-width: 6;
                            stroke-dasharray: 2, 4;
                          "
                          marker-start="url(#arrow)"
                        />
                      </svg>
                    </div>
                    <v-col
                        class="align-self-end"
                        :style="{
                        border: '1px solid ' + getColorPosition(2),
                        'background-color': getBackgroundColorPosition(2),
                        'border-radius': '16px !important',
                        'box-shadow':
                          '0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12) !important',
                        'z-index': '9999',
                        height: '50px',
                      }"
                        @click="setOverTimeChartDateFromJourney('SMOKECESSATION')"
                    >
                      <smart-icon
                          icon="mdi-smoking-off"
                          :iconColor="getColorPosition(2)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <!-- Stress relief -->
                <v-col cols="auto" style="height: 250px">
                  <v-row
                      :style="{ height: heightPosition(4) + 'px' }"
                      class="mt-n3 your-journey__item"
                  >
                    <div class="your-journey__item-line">
                      <svg :height="heightPosition(4)" width="100%">
                        <defs>
                          <marker id="arrow" viewBox="0 0 10 10" refX="1" refY="5" markerWidth="3" markerHeight="4" orient="270">
                            <path fill="#f0f0f0" d="M 0 0 L 10 5 L 0 10 z" />
                          </marker>
                        </defs>
                        <line
                          x1="24"
                          y1="16"
                          x2="24"
                          y2="250"
                          style="
                            stroke: #f0f0f0;
                            stroke-width: 6;
                            stroke-dasharray: 2, 4;
                          "
                          marker-start="url(#arrow)"
                        />
                      </svg>
                    </div>
                    <v-col
                        class="align-self-end"
                        :style="{
                        border: '1px solid ' + getColorPosition(4),
                        'background-color': getBackgroundColorPosition(4),
                        'border-radius': '16px !important',
                        'box-shadow':
                          '0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12) !important',
                        'z-index': '9999',
                        height: '50px',
                      }"
                        @click="
                        setOverTimeChartDateFromJourney('STRESSMANAGEMENT')
                      "
                    >
                      <smart-icon
                          icon="mdi-meditation"
                          :iconColor="getColorPosition(4)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="7">
        <!----------------------------------------- Time line ----------------------------------------->
        <v-row v-if="patientHad2ndSDMEncounter" class="border ma-2 ml-0">
          <v-col cols="12">
            <v-row>
              <v-col>
                <h3>{{ $ucfirst($t("journeyProgress.yourTimeLine")) }}</h3>
              </v-col>
            </v-row>
            <v-row class="no-gutters mt-4">
              <!-- Icons -->
              <v-col cols="1" class="pl-5">
                <v-row class="align-self-center mt-10">
                  <v-col
                      cols="12"
                      class="border mb-4 c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                  >
                    <a
                        class="pa-1 px-3"
                        @click="
                        setOverTimeChartDataFromTimeLineBehaviourComponent(
                          'MEDICATIONS'
                        )
                      "
                    >
                      <smart-icon icon="mdi-pill"/>
                    </a>
                  </v-col>

                  <v-spacer/>
                  <v-col
                      cols="12 border mb-4 c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                  >
                    <a
                        class="pa-1 px-3"
                        @click="
                        setOverTimeChartDataFromTimeLineBehaviourComponent(
                          'STARTMOVING'
                        )
                      "
                    >
                      <smart-icon icon="mdi-run"/>
                    </a>
                  </v-col>
                  <v-spacer/>
                  <v-col
                      cols="12 border mb-4 c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                  >
                    <a
                        class="pa-1 px-3"
                        @click="
                        setOverTimeChartDataFromTimeLineBehaviourComponent(
                          'HEALTHYNUTRITION'
                        )
                      "
                    >
                      <smart-icon icon="mdi-silverware-fork-knife"/>
                    </a>
                  </v-col>
                  <v-spacer/>
                  <v-col
                      cols="12 border mb-4 c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                  >
                    <a
                        class="pa-1 px-3"
                        @click="
                        setOverTimeChartDataFromTimeLineBehaviourComponent(
                          'SMOKECESSATION'
                        )
                      "
                    >
                      <smart-icon icon="mdi-smoking-off"/>
                    </a>
                  </v-col>
                  <v-spacer/>
                  <v-col
                      cols="12 border mb-4 c-timeline__icon pa-0"
                      align="center"
                      justify="center"
                  >
                    <a
                        class="pa-1 px-3"
                        @click="
                        setOverTimeChartDataFromTimeLineBehaviourComponent(
                          'STRESSMANAGEMENT'
                        )
                      "
                    >
                      <smart-icon icon="mdi-meditation"/>
                    </a>
                  </v-col>
                  <v-spacer/>
                </v-row>
              </v-col>
              <!-- Chart -->
              <v-col cols="9">
                <apexchart
                    type="rangeBar"
                    height="330px"
                    width="100%"
                    :options="chartOptions"
                    :series="series"
                    class="c-timeline__apexchart"
                ></apexchart>
              </v-col>
              <v-col cols="2">
                <div class="c-timeline__legend-wrapper">
                  <div
                      v-for="legend in legends"
                      class="c-timeline__legend-small"
                      :key="legend.name"
                  >
                    <v-icon small :color="legend.color">mdi-circle</v-icon>
                    <p class="mb-0 ml-1">{{ legend.name }}</p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!----------------------------------------- Over Time ----------------------------------------->
        <v-row class="border ma-2 ml-0" v-if="this.showOverTime">
          <v-col cols="12" lg="6" class="py-5">
            <h3 class="text-wrap">
              {{ getChartOverTimeTitle() }}
            </h3>
          </v-col>
          <v-col cols="12" lg="6" class="py-5">
            <v-row no-gutters>
              <v-col class="mr-4">
                <span class="v-patient-overview-medication-progress__label">
                  {{ $ucfirst($t("general.from", {catalog: "app_mobile"})) }}
                </span>
                <date-picker
                    v-model="fromDate"
                    :datePickerAttr="{
                      min: visit1Date.format('YYYY-MM-DD'),
                      max: this.moment(untilDate).format('YYYY-MM-DD'),
                    }"
                    :disabledDateMessage="$ucfirst($t('validation.invalidDate.dateFromEnrolment'))"
                    :hideMessageFromDate="visit1Date.format('YYYY-MM-DD')"
                    :hideMessageUntilDate="this.moment().format('YYYY-MM-DD')"
                />
              </v-col>
              <v-col>
                <span class="v-patient-overview-medication-progress__label">
                  {{ $ucfirst($t("general.until", {catalog: "app_mobile"})) }}
                </span>
                <date-picker
                    v-model="untilDate"
                    :alignRight="true"
                    :datePickerAttr="{
                      min: this.moment(fromDate).format('YYYY-MM-DD'),
                      max: this.moment().format('YYYY-MM-DD'),
                    }"
                    :disabledDateMessage="$ucfirst($t('validation.invalidDate.dateFromEnrolment'))"
                    :hideMessageFromDate="visit1Date.format('YYYY-MM-DD')"
                    :hideMessageUntilDate="this.moment().format('YYYY-MM-DD')"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col
                  :cols="
                  this.overTimeChartBehaviourGoal == 'SMOKECESSATION' ||
                  this.overTimeChartBehaviourGoal == 'STRESSMANAGEMENT'
                    ? 6
                    : 12
                "
              >
                <apexchart
                    type="line"
                    height="350"
                    :options="chartOptionsOverTime"
                    :series="seriesOverTime"
                ></apexchart>
              </v-col>
              <v-col
                  cols="6"
                  v-if="
                  this.overTimeChartBehaviourGoal == 'SMOKECESSATION' ||
                  this.overTimeChartBehaviourGoal == 'STRESSMANAGEMENT'
                "
              >
                <apexchart
                    type="line"
                    height="350"
                    :options="chartOptionsOverTimeRight"
                    :series="seriesOverTimeRight"
                ></apexchart>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-tooltip
      bottom
      v-model="showLabelTooltip"
      :position-x="labelTooltipX"
      :position-y="labelTooltipY"
      :max-width="200"
      content-class="progress-status-journey__label-tooltip"
    >
      {{ labelTooltipText }}
    </v-tooltip>
  </v-container>
</template>

<script>
import SmartIcon from "../../../components/Parts/SmartIcon.vue";
import gql from "graphql-tag";
import Moment from "moment";
import {extendMoment} from "moment-range";
import VueApexCharts from "vue-apexcharts";
import DatePicker from "../../../components/Parts/DatePicker.vue";
import {mapGetters} from "vuex";
import {groupBy} from "../../../../../helper/arrays";

/**
 * Component ProgressStatusJourney.vue
 *
 * @module ProgressStatusJourney
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/ProgressStatusJourney.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

const moment = extendMoment(Moment);

export default {
  name: "PatientOverviewMain",
  components: {
    SmartIcon,
    apexchart: VueApexCharts,
    DatePicker,
  },
  data: function () {
    return {
      // Timeline chart data
      series: [
        {
          data: [],
        },
      ],

      // OverTime chart data
      seriesOverTime: [
        {
          data: [],
        },
      ],

      // OverTime chart data right
      seriesOverTimeRight: [
        {
          data: [],
        },
      ],

      // behaviour component to show in OverTime chart
      overTimeChartBehaviourGoal: null,
      overTimeChartBehaviourGoalsData: [[], [], [], [], []],
      yAxisOverTimeMax: 7,
      annotationsOverTime: {},
      fromDate: moment().format("YYYY-MM-DD"),
      untilDate: moment().format("YYYY-MM-DD"),
      showOverTime: false,
      legends: [],
      showLabelTooltip: false,
      labelTooltipX: null,
      labelTooltipY: null,
      labelTooltipText: '',

      journeyProgress: null,
      myJourneyGoals: null,
      encounters: [],
      myBehaviourComponentLogs: null,
      icons: [
        "mdi-pill",
        "mdi-run",
        "mdi-silverware-fork-knife",
        "mdi-smoking-off",
        "mdi-meditation",
      ],
      behaviourComponents: [
        "MEDICATIONS",
        "STARTMOVING",
        "HEALTHYNUTRITION",
        "SMOKECESSATION",
        "STRESSMANAGEMENT",
      ],

      // positionColors: [
      //   {
      //     color: "#66DD9C",
      //     bg_color: "#F0FEF4",
      //   },
      //   {
      //     color: "#c9db46",
      //     bg_color: "#f8ffe3",
      //   },
      //   {
      //     color: "#f2aa3c",
      //     bg_color: "#fefae2",
      //   },
      //   {
      //     color: "#ee7d30",
      //     bg_color: "#fdf5f3",
      //   },
      //   {
      //     color: "#eb4f73",
      //     bg_color: "#fdf2f2",
      //   },
      //   {
      //     color: this.$color.coro["gray"],
      //     bg_color: this.$color.coro["lightgray"],
      //   },
      // ],
      positionColors: [
        {
          color: "#eb4f73",
          bg_color: "#fdf2f2",
        },
        {
          color: "#ee7d30",
          bg_color: "#fdf5f3",
        },
        {
          color: "#f2aa3c",
          bg_color: "#fefae2",
        },
        {
          color: "#c9db46",
          bg_color: "#f8ffe3",
        },
        {
          color: "#66DD9C",
          bg_color: "#F0FEF4",
        },
        {
          color: this.$color.coro["gray"],
          bg_color: this.$color.coro["lightgray"],
        },
      ],
      timelineColors: [
        this.$color.coro["lightgray2"],
        this.$color.coro["primary-200"],
        this.$color.coro["primary-300"],
        this.$color.coro["primary-400"],
        this.$color.coro["primary-500"],
      ],

      sliderValue: 0,
      visibleJourneyProgress: [
        {
          __typename: "JourneyGoal",
          distance: 1,
          extraInformation:
              '{"LOG":1,"PA:30MIN_OR_MORE":null,"daysStepLevelInactive":7,"daysStepLevelBeginner":0,"daysStepLevelIntermediate":0,"daysStepLevelAdvanced":0}',
          id: "107d251d-febb-4fb2-a756-7bd63ec590a0",
          key: "STARTMOVING",
          startDate: "2021-04-19 00:00:00",
        },
        {
          __typename: "JourneyGoal",
          distance: 3,
          extraInformation:
              '{"LOG":1,"MA:TAKING_AS_PRESCRIBED":"MOSTLY","MA:TAKING_AS_PRESCRIBED:ANSWER_NUMBER":5,"medicationAdherence":100}',
          id: "75772771-595e-47de-a889-644bc912c097",
          key: "MEDICATIONS",
          startDate: "2021-04-19 00:00:00",
        },
        {
          __typename: "JourneyGoal",
          distance: 0,
          extraInformation: "[]",
          id: "a3be5910-6f2c-4d31-b301-9e30977030e9",
          key: "SMOKECESSATION",
          startDate: "2021-04-19 00:00:00",
        },
        {
          __typename: "JourneyGoal",
          distance: 0,
          extraInformation: "[]",
          id: "eec3049c-bf9b-4596-b5ad-ca0c9ca9a500",
          key: "HEALTHYNUTRITION",
          startDate: "2021-04-19 00:00:00",
        },
        {
          __typename: "JourneyGoal",
          distance: 0,
          extraInformation: "[]",
          id: "2bdca567-baaa-438d-8981-cc64e87aeec4",
          key: "STRESSMANAGEMENT",
          startDate: "2021-04-19 00:00:00",
        },
      ],
      timelineXAxisFormat: {},
      timelineXAxisLabelCount: {},
      overTimeChartXAxisTickAmount: null,
      overTimeChartRightXAxisTickAmount: null
    };
  },

  watch: {
    sliderValue(current) {
      if (this.journeyProgress !== null) {
        let selectedKey = Object.keys(this.journeyProgress)[current];
        this.visibleJourneyProgress = this.journeyProgress[selectedKey];
      }
    },
    overTimeChartBehaviourGoal() {
      this.setOverTimeChartSeries();
    },
    fromDate() {
      this.setOverTimeChartSeries();
    },
    untilDate() {
      this.setOverTimeChartSeries();
    },
    yAxisOverTimeMax() {
      this.setOverTimeChartSeries();
    },
  },

  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      currentVersion: "patientSummary/currentVersion",
      isModuleEnabled: "enabledModules/getIsModuleEnabled",
      lastCompletedSDMEncounterDate : "patientSummary/lastCompletedSDMEncounterDate",
      isSDM: "followupSession/isSDMStarted"
    }),
    visit1Date() {
      const v1 = this.$store.getters["patientSummary/visit1Date"];
      return v1 ? moment(v1) : moment();
    },
    moment: () => moment,
    patientHad2ndSDMEncounter() {
      const version = parseInt(this.currentVersion)
      return (version === 3 && this.isSDM) || version >= 4;
    },
    selectedWeekSlider: function () {
      if (this.journeyProgress != null) {
        let key = Object.keys(this.journeyProgress)[this.sliderValue];
        return moment(key).format("DD-MM-YYYY");
      } else {
        return "";
      }
    },
    // Chartoptions are computed for the onclick to be able to execute setOverTimeChartDataFromTimeLineData / getBehaviourComponentLabel functions
    chartOptions: function () {
      return {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          width: "100%",
          type: "rangeBar",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.setOverTimeChartDataFromTimeLineData(config.dataPointIndex);
            },
            mouseMove: (event) => {
              // show tooltip on annotation hover
              this.setAnnotationTooltip(event);
            },
          },
          ...this.$app.apexChartHelper.getMonthTranslations()
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            borderRadius: 10,
            dataLabels: {
              hideOverflowingLabels: true,
            },
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value, {seriesIndex, dataPointIndex, w}) => {
              return this.getBehaviourComponentLabel(
                  w.config.series[seriesIndex].data[dataPointIndex].x,
                  w.config.series[seriesIndex].data[dataPointIndex].name
              );
            },
          },
          x: {
            format: 'dd MMMM',
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, {seriesIndex, dataPointIndex, w}) {
            return w.config.series[seriesIndex].data[dataPointIndex].name;
          },
          style: {
            colors: ["#f3f4f5", "#fff"],
          },
        },
        xaxis: {
          show: true,
          type: "datetime",
          position: "bottom",
          axisTicks: {
            show: false,
            borderType: "solid",
          },
          labels: {
            show: true,
            datetimeFormatter: {
              month: "MMMM 'yy",
              year: "MMMM 'yy",
              day: "dd MMMM",
              hour: "",
            },
            rotate: -30,
            minHeight: 60,
            rotateAlways: true,
            hideOverlappingLabels: false,
            style: {
              fontSize: '0.75rem'
            },
            ...this.timelineXAxisFormat
          },
          ...this.timelineXAxisLabelCount
        },
        yaxis: {
          show: false,
        },
        annotations: {
          xaxis: this.setAnnotationsSDMEncounters(),
        },
        grid: {
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
      };
    },

    // ChartOption Over time
    chartOptionsOverTime: function () {
      return {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          events: {
            mouseMove: (event) => {
              // show tooltip on y axis label hover
              this.setChartOverTimeLabelTooltip(event);
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          // type: "datetime",
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.75rem'
            },
            offsetY: 10,
          },
          labels: {
            formatter: (val) => {
              return moment(val).format('DD/MM');
            },
            style: {
              fontSize: '0.75rem'
            },
            minHeight: 60,
          },
          tickAmount: this.overTimeChartXAxisTickAmount
        },
        yaxis: {
          title: {
            text: this.getYAxisOverTimeLabel(this.overTimeChartBehaviourGoal),
            style: {
              fontSize: '0.75rem'
            }
          },
          min: 0,
          max: this.yAxisOverTimeMax,
          tickAmount: this.yAxisOverTimeMax,
          labels: {
            minWidth: 120,
            formatter: (val) => {
              return this.truncateString(this.formatLabelOverTime(val, false), 16)
            },
            style: {
              fontSize: '0.75rem'
            }
          },
        },
        tooltip: {
          y: {
            title: {
              formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                return w.config.yaxis[0]?.title?.text + ':'
              }
            },
            formatter: (value, {series, seriesIndex, dataPointIndex, w}) => {
              const label = w.globals.initialSeries[seriesIndex].data[dataPointIndex].y;
              return this.formatLabelOverTime(label, false)
            },
          },
          style: {
            fontSize: '0.85rem',
          },
        },
        markers: {
          size: 4,
          strokeWidth: 1,
          hover: {
            size: 6,
          }
        },
        annotations: this.annotationsOverTime,
        noData: {
          text: this.$t("noData"),
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: -32,
          style: {
            // color: this.$color.coro["primary-500"],
            fontSize: "22px",
            fontFamily: "Futura",
          },
        },
      };
    },

    // ChartOption Over time
    chartOptionsOverTimeRight: function () {
      return {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          events: {
            mouseMove: (event) => {
              // show tooltip on y axis label hover
              this.setChartOverTimeLabelTooltip(event, true);
            },
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          // type: "datetime",
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.75rem'
            },
          },
          labels: {
            formatter: (val) => {
              return moment(val).format('DD/MM');
            },
            style: {
              fontSize: '0.75rem'
            },
          },
          tickAmount: this.overTimeChartRightXAxisTickAmount
        },
        yaxis: {
          title: {
            text: this.getYAxisOverTimeLabel(this.overTimeChartBehaviourGoal, true),
            style: {
              fontSize: '0.75rem'
            },
            offsetY: 10,
          },
          min: 0,
          max: this.yAxisOverTimeMaxRigth,
          tickAmount: this.yAxisOverTimeMaxRigth,
          labels: {
            minWidth: 110,
            formatter: (val) => {
              return this.truncateString(this.formatLabelOverTime(val, true), 16)
            },
            style: {
              fontSize: '0.75rem'
            },
          },
        },
        tooltip: {
          y: {
            title: {
              formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                return w.config.yaxis[0]?.title?.text + ':'
              }
            },
            formatter: (value, {series, seriesIndex, dataPointIndex, w}) => {
              const label = w.globals.initialSeries[seriesIndex].data[dataPointIndex].y;
              return this.formatLabelOverTime(label, true)
            },
          },
          style: {
            fontSize: '0.85rem'
          }
        },
        markers: {
          size: 4,
          strokeWidth: 1,
          hover: {
            size: 6,
          }
        },
        annotations: this.annotationsOverTime,
        noData: {
          text: this.$t("noData"),
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: -32,
          style: {
            // color: this.$color.coro["primary-500"],
            fontSize: "22px",
            fontFamily: "Futura",
          },
        },
      };
    },
    isSliderAvailable() {
      if (!this.journeyProgress) {
        return false;
      }

      return Object.keys(this.journeyProgress).length > 1
    }
  },

  mounted: async function () {
    const journeyCalculator = this.$app.patientManager.makeJourneyCalculator(
        this.patientId,
        this.visit1Date
    );
    this.getJourneyProgressGroupedByDate();
    this.getTimeLineData();
    await journeyCalculator.loadMyBehaviourComponentLogs();
    this.overTimeChartBehaviourGoalsData =
        journeyCalculator.overTimeChartBehaviourGoalsData;
    this.encounters = this.$store.getters["patientSummary/SDMEncounters"];
  },

  methods: {
    // return height (in px) for position of icon from the be healthy goal
    heightPosition(index) {
      // Not active
      if (
          !this.visibleJourneyProgress ||
          !this.visibleJourneyProgress[index]?.id ||
          this.visibleJourneyProgress[index].distance === null
      ) {
        return 50;
      } else {
        return (4 - this.visibleJourneyProgress[index].distance) * 50 + 50;
      }
    },

    // Color based on position
    getColorPosition(index) {
      if (
          !this.visibleJourneyProgress ||
          !this.visibleJourneyProgress[index]?.id ||
          this.visibleJourneyProgress[index].distance === null
      ) {
        return this.positionColors[5].color;
      } else {
        return this.positionColors[this.visibleJourneyProgress[index].distance]
            .color;
      }
    },

    // backgroundColor based on position
    getBackgroundColorPosition(index) {
      if (
          !this.visibleJourneyProgress ||
          !this.visibleJourneyProgress[index]?.id ||
          this.visibleJourneyProgress[index].distance === null
      ) {
        return this.positionColors[5].bg_color;
      } else {
        return this.positionColors[this.visibleJourneyProgress[index].distance]
            .bg_color;
      }
    },

    getBehaviourComponentLabel(labelKey, name) {
      let _LOG = name === " " ? "0" : name;
      let LOG_name = this.getLevelOfGuidanceLabel(_LOG, labelKey)

      return (
        `${this.$app.behaviourComponentManager.getBehaviourComponentName(labelKey)}
         ${this.$t("journeyProgress.levelOfGuidance")}
         ${_LOG}${LOG_name ? ' - ' + LOG_name : ''}: `
      );
    },

    getChartOverTimeTitle() {
      let label = ''

      if (this.overTimeChartBehaviourGoal === 'MEDICATIONS') {
        label = this.$t('medication.medicationAdherence');
      } else if (this.overTimeChartBehaviourGoal === 'HEALTHYNUTRITION') {
        label = this.$t('knowledge.questions.myheart.advanced.healthprogramtarget.answers.nutrition',
          { catalog: 'content' }
        );
      } else {
        label = this.$t('behaviourComponentJourney.' + this.overTimeChartBehaviourGoal);
      }

      return this.$ucfirst(this.$t("dummy.journeyProgress.overTime", {
        params: { behaviourComponent: label },
      }));
    },

    getLevelOfGuidanceLabel(log, key) {
      const isMedication = key === 'MEDICATIONS'

      switch(log) {
        case '1':
          return isMedication
            ? this.$ucfirst(this.$t(
                'journeyFormulationAdherence.optimiseAdherence',
                { catalog: 'app_mobile' }
              ))
            : this.$ucfirst(this.$t(
                'journeyFormulation.learn', { catalog: 'app_mobile' }
              ))
        case '2':
          return isMedication
            ? this.$ucfirst(this.$t(
                'journeyFormulationAdherence.maintainHealthyHabit',
                { catalog: 'app_mobile' }
              ))
              // Note: LOG change
              // Used to be 'Plan your exercise'
            : this.$ucfirst(this.$t(
                'journeyFormulation.trackGoals', { catalog: 'app_mobile' }
              ))
        case '3':
          return this.$ucfirst(this.$t(
            'journeyFormulationAdherence.maintainHealthyHabit',
            { catalog: 'app_mobile' }
          ))
        default:
          return this.$ucfirst(this.$t(
              'physicalActivityStepGoals.inactive',
              { catalog: 'app_mobile' }
          ))
      }
    },

    formatLabelOverTime(val, right = false) {
      if (this.overTimeChartBehaviourGoal === "MEDICATIONS") {
        switch (val) {
          case 0:
            return this.$t("medicationAdherenceProgress.never");
          case 1:
            return this.$t("medicationAdherenceProgress.rarely");
          case 2:
            return this.$t("medicationAdherenceProgress.sometimes");
          case 3:
            return this.$t("medicationAdherenceProgress.often");
          case 4:
            return this.$t("medicationAdherenceProgress.mostly");
          case 5:
            return this.$t("medicationAdherenceProgress.always");
          default:
            return;
        }
      } else if (this.overTimeChartBehaviourGoal === "STARTMOVING") {
        switch (val) {
          case 0:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_0_DAYS", {
              catalog: "questionnaires",
            });
          case 1:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_1_DAY", {
              catalog: "questionnaires",
            });
          case 2:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_2_DAYS", {
              catalog: "questionnaires",
            });
          case 3:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_3_DAYS", {
              catalog: "questionnaires",
            });
          case 4:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_4_DAYS", {
              catalog: "questionnaires",
            });
          case 5:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_5_DAYS", {
              catalog: "questionnaires",
            });
          case 6:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_6_DAYS", {
              catalog: "questionnaires",
            });
          case 7:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_7_DAYS", {
              catalog: "questionnaires",
            });
          default:
            return;
        }
      } else if (this.overTimeChartBehaviourGoal === "HEALTHYNUTRITION") {
        switch (val) {
          case 0:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_POOR", {
              catalog: "questionnaires"
            });
          case 1:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_FAIR", {
              catalog: "questionnaires"
            });
          case 2:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_GOOD", {
              catalog: "questionnaires"
            });
          case 3:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_VERY_GOOD", {
              catalog: "questionnaires"
            });
          case 4:
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_EXCELLENT", {
              catalog: "questionnaires"
            });
          default:
            return;
        }
      } else if (this.overTimeChartBehaviourGoal === "SMOKECESSATION") {
        if (right) {
          switch (val) {
            case 0:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_DONT_STOP", {
                catalog: "questionnaires"
              });
            case 1:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_SHOULD_STOP", {
                catalog: "questionnaires"
              });
            case 2:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_WANT_STOP_WHEN", {
                catalog: "questionnaires"
              });
            case 3:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_REALLY_WANT_WHEN", {
                catalog: "questionnaires"
              });
            case 4:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_WANT_STOP_SOON", {
                catalog: "questionnaires"
              });
            case 5:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_REALLY_WANT_3_MONTHS", {
                catalog: "questionnaires"
              });
            case 6:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_REALLY_WANT_NEXT_MONTH", {
                catalog: "questionnaires"
              });
            default:
              return;
          }
        } else {
          if (val === 0) {
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_YES", {
              catalog: "questionnaires",
            });
          } else {
            return this.$t("questionnaires.MY_MOTIVATION.questions.A_NO", {
              catalog: "questionnaires",
            });
          }
        }
      } else if (this.overTimeChartBehaviourGoal === "STRESSMANAGEMENT") {
        if (right) {
          switch (val) {
            case 0:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_NEVER", {
                catalog: "questionnaires",
              });
            case 1:
              return this.$t(
                  "questionnaires.MY_MOTIVATION.questions.A_RARELY",
                  {catalog: "questionnaires"}
              );
            case 2:
              return this.$t(
                  "questionnaires.MY_MOTIVATION.questions.A_SOMETIMES",
                  {catalog: "questionnaires"}
              );
            case 3:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_OFTEN", {
                catalog: "questionnaires",
              });
            case 4:
              return this.$t(
                  "questionnaires.MY_MOTIVATION.questions.A_ALWAYS",
                  {catalog: "questionnaires"}
              );
            default:
              return;
          }
        } else {
          switch (val) {
            case 0:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_NOT_AT_ALL", {
                catalog: "questionnaires"
              });
            case 1:
              return this.truncateString(this.$t("questionnaires.MY_MOTIVATION.questions.A_ONLY_A_LITTLE", {
                catalog: "questionnaires"
              }), 13);
            case 2:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_TO_SOME_EXTEND", {
                catalog: "questionnaires"
              });
            case 3:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_RATHER_MUCH", {
                catalog: "questionnaires"
              });
            case 4:
              return this.$t("questionnaires.MY_MOTIVATION.questions.A_VERY_MUCH", {
                catalog: "questionnaires"
              });
            default:
              return;
          }
        }
      }
    },

    getYAxisOverTimeLabel(behaviourGoal, right) {
      switch (behaviourGoal) {
        case "MEDICATIONS":
          return this.$ucfirst(this.$t('journeyOverTime.TAKE_MEDICATION'))
        case "STARTMOVING":
          return this.$ucfirst(this.$t('journeyOverTime.ACTIVE_DAYS'))
        case "HEALTHYNUTRITION":
          return this.$ucfirst(this.$t('journeyOverTime.HEALTHINESS_OF_DIET'))
        case "SMOKECESSATION":
          if (right) {
            return this.$ucfirst(this.$t('questionnaires.MOTIVATION_STOP_SMOKING.name', {catalog: 'questionnaires'}))
          } else {
            return this.$ucfirst(this.$t('journeyOverTime.DOES_PATIENT_SMOKE'))
          }
        case "STRESSMANAGEMENT":
          if (right) {
            return this.$ucfirst(this.$t('behaviourComponentJourney.COPINGMEASUREMENTS'))
          } else {
            return this.$ucfirst(this.$t('journeyOverTime.STRESS_LEVEL'))
          }
      }
    },

    getJourneyProgressGroupedByDate() {
      this.$app.apolloMobileClient
          .query({
            query: gql`
            query myJourneyGoals($patientId: String!) {
              myJourneyGoals(
                functions: [{ function: patientId, parameters: [$patientId] }]
                orders : [{field : startDate, direction : asc}]
              ) {
                id
                key
                startDate
                distance
                extraInformation
              }
            }
          `,
            variables: {
              patientId: this.patientId,
            },
          })
          .then((result) => {
            let groupedByDate = groupBy(result.data.myJourneyGoals, "startDate");
            this.myJourneyGoals = result.data.myJourneyGoals;
            let _dates = Object.keys(groupedByDate);
            let _lastKey = _dates[_dates.length - 1];
            this.journeyProgress = groupedByDate;
            this.visibleJourneyProgress = groupedByDate[_lastKey];
            this.sliderValue = _dates.length - 1;
          });
    },

    truncateString(string, length) {
      if (string.length <= length) {
        return string;
      }
      return string.substring(0, length) + '...'
    },

    getTimeLineData() {
      let _splitSeries = {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
      };
      this.$app.apolloMobileClient
          .query({
            query: gql`
            query myBehaviourComponentLogs($patientId: String!) {
              myBehaviourComponentLogs(
                orders: [{ field: createdAt, direction: asc }]
                functions: [{ function: patientId, parameters: [$patientId] }]
              ) {
                logId
                oldLevel
                newLevel
                createdAt
                component {
                  key
                }
              }
            }
          `,
            variables: {
              patientId: this.patientId,
            },
          })
          .then((result) => {
            // console.log(result.data.myBehaviourComponentLogs[0]);
            this.myBehaviourComponentLogs = result.data.myBehaviourComponentLogs;
            this.behaviourComponents.map((behaviourComponent, index) => {
              // For every behaviourComponent filter results on the behaviourComponent
              let behaviourComponentSpecificLogs =
                  result.data.myBehaviourComponentLogs.filter((log) => {
                    return log.component.key == behaviourComponent;
                  });
              // Loop all changes for specific behaviourComponent
              behaviourComponentSpecificLogs.map((log, specificIndex) => {
                let level = parseInt(log.newLevel);

                // Only 1 LOG
                if (behaviourComponentSpecificLogs.length == 1) {
                  _splitSeries[index].push({
                    x: log.component.key,
                    y: [moment(log.createdAt).valueOf(), moment().valueOf()],
                    name: level.toString() != "0" ? level.toString() : " ",
                    fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS'),
                  });
                } else {
                  // If LOG is last
                  if (
                      specificIndex ==
                      behaviourComponentSpecificLogs.length - 1
                  ) {
                    _splitSeries[index].push({
                      x: log.component.key,
                      y: [moment(log.createdAt).valueOf(), moment().valueOf()],
                      name: level.toString() != "0" ? level.toString() : " ",
                      fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS'),
                    });
                  } else {
                    _splitSeries[index].push({
                      x: log.component.key,
                      y: [
                        moment(log.createdAt).valueOf(),
                        moment(
                            behaviourComponentSpecificLogs[specificIndex + 1]
                                .createdAt
                        ).valueOf(),
                      ],
                      name: level.toString() != "0" ? level.toString() : " ",
                      fillColor: this.getLevelOfGuidanceColor(level, log.component.key === 'MEDICATIONS'),
                    });
                  }
                }
              });
              // Add LOG 0 from beginning of enrollment untill first change
              if (
                  _splitSeries[index][0] != null &&
                  moment(_splitSeries[index][0].y[0]).isAfter(this.visit1Date)
              ) {
                _splitSeries[index].unshift({
                  x: behaviourComponent,
                  y: [
                    this.visit1Date.valueOf(),
                    moment(_splitSeries[index][0].y[0]).valueOf(),
                  ],
                  name: " ",
                  fillColor: this.timelineColors[0],
                });
              }
            });
            // Create series object
            let _series = [
              ..._splitSeries[0],
              ..._splitSeries[1],
              ..._splitSeries[2],
              ..._splitSeries[3],
              ..._splitSeries[4],
            ];

            const legends = [];
            _series.forEach(item => {
              const isMedication = item.x === 'MEDICATIONS';
              if (item.name && !legends.find(i => i.name === this.getLevelOfGuidanceName(+item.name, isMedication))) {

                // adjust sorting for MEDICATIONS
                let sortKey = +item.name;
                if (isMedication && sortKey === 1) {
                  sortKey = 2;
                } else if (isMedication && +sortKey === 2) {
                  sortKey = 3;
                }

                legends.push({
                  sortKey: sortKey,
                  name: this.getLevelOfGuidanceName(+item.name, isMedication),
                  color: item.fillColor
                })
              }
            })
            const sorted = legends.sort((a, b) => (a.sortKey > b.sortKey) ? 1 : ((b.sortKey > a.sortKey) ? -1 : 0))
            this.legends = sorted;

            this.formatTimelineXAxisLabels();

            this.series = [
              {
                data: _series,
              },
            ];
          });
    },

    formatTimelineXAxisLabels() {
      const fullPeriod = moment().diff(moment(this.visit1Date), 'hours');

      // format labels if full graph period is less than 2 days - will hide hours
      if (fullPeriod < 48) {
        this.timelineXAxisFormat = {
          formatter: (value) => {
            return moment(value).format('DD') + ' ' +
              this.$ucfirst(this.$t(`date.MMMM-${moment(value).format('MM')}`))
          },
        };
        this.timelineXAxisLabelCount = {
          tickAmount: 3
        }
      }
    },

    getLevelOfGuidanceName(log, isMedication) {
      switch (log) {
        case 0:
          return this.$t('physicalActivityStepGoals.inactive', {catalog: 'app_mobile'})
        case 1:
          if (isMedication) {
            return this.$t('journeyBehaviourChangeGoals.monitoredAction')
          } else {
            return this.$t('journeyBehaviourChangeGoals.startAction')
          }
        case 2:
          if (isMedication) {
            return this.$t('journeyBehaviourChangeGoals.maintainedBehavior')
          } else {
            // Note: LOG change
            // Used to be 'Planned Action'
            return this.$t('journeyBehaviourChangeGoals.monitoredAction')
          }
        case 3:
          return this.$t('journeyBehaviourChangeGoals.maintainedBehavior')
        default:
          return '';
      }
    },

    getLevelOfGuidanceColor(log, isMedication) {
      if (isMedication && log) {
        return this.timelineColors[log + 1]
      }
      return this.timelineColors[log]
    },

    // Set y axis to amount of possible answers
    setYAxisOverTimeMax() {
      switch (this.overTimeChartBehaviourGoal) {
        case "MEDICATIONS":
          this.yAxisOverTimeMax = 5;
          break;
        case "STARTMOVING":
          this.yAxisOverTimeMax = 7;
          break;
        case "HEALTHYNUTRITION":
          this.yAxisOverTimeMax = 4;
          break;
        case "SMOKECESSATION":
          this.yAxisOverTimeMax = 1;
          this.yAxisOverTimeMaxRigth = 6;
          break;
        case "STRESSMANAGEMENT":
          this.yAxisOverTimeMax = 4;
          this.yAxisOverTimeMaxRigth = 4;
          break;
      }
    },

    setOverTimeChartSeries() {
      this.setYAxisOverTimeMax();

      let _labelStyle = {
        borderWidth: "0",
        textAnchor: "middle",
        position: "top",
        orientation: "horizontal",
        offsetY: 15,
        offsetX: 15,
        style: {
          background: "transparent",
          fontSize: "18px",
          color: "white",
          fontWeight: 400,
        },
      };

      // gets the index of the selected behaviourComponent
      let _overTimeChartBehaviourGoalIndex = null;
      this.behaviourComponents.map((behaviourComponent, index) => {
        if (behaviourComponent == this.overTimeChartBehaviourGoal) {
          _overTimeChartBehaviourGoalIndex = index;
        }
      });
      let _fromDate = moment(this.fromDate, "YYYY-MM-DD HH:mm:ss");
      let _untilDate = moment(this.untilDate + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
      const daysDifferance = moment(_untilDate).diff(_fromDate, 'days')

      // If untilDate is before fromDate set empty data (TODO error handling)
      if (
          _fromDate.isAfter(_untilDate) ||
          _overTimeChartBehaviourGoalIndex < 0
      ) {
        this.seriesOverTime = [
          {
            data: [],
          },
        ];
        // Set annotations (will be copied in computed)
        this.annotationsOverTime = [];
      } else {
        // Calculate what weeks to show
        // overTimeChartBehaviourGoalsData is set in each behaviour component logic

        if (_overTimeChartBehaviourGoalIndex > 2) {
          let _dataLeft = this.overTimeChartBehaviourGoalsData[
              _overTimeChartBehaviourGoalIndex
              ].left.filter((data) => {
            if (
                moment(data.x).isSameOrAfter(moment(_fromDate), "day") &&
                moment(data.x).isSameOrBefore(moment(_untilDate), "day")
            ) {
              return data;
            }
          });
          let _dataRight = this.overTimeChartBehaviourGoalsData[
              _overTimeChartBehaviourGoalIndex
              ].right.filter((data) => {
            if (
                moment(data.x).isSameOrAfter(moment(_fromDate), "day") &&
                moment(data.x).isSameOrBefore(moment(_untilDate), "day")
            ) {
              return data;
            }
          });

          // Add fromDate and untillDate to get full graph.
            _dataLeft.unshift({
              x: moment(_fromDate).valueOf(),
              y: null,
            });
            _dataLeft.push({
              x: moment(_untilDate).valueOf(),
              y: null,
            });
            _dataRight.unshift({
              x: moment(_fromDate).valueOf(),
              y: null,
            });
            _dataRight.push({
              x: moment(_untilDate).valueOf(),
              y: null,
            });

          // set tickAmount in order to avoid identical labels in given period
          if (daysDifferance < _dataLeft.length) {
            this.overTimeChartXAxisTickAmount = daysDifferance < 1 ? daysDifferance + 1 : daysDifferance
          }
          if (daysDifferance < _dataRight.length) {
            this.overTimeChartRightXAxisTickAmount = daysDifferance < 1 ? daysDifferance + 1 : daysDifferance
          }

          this.seriesOverTime = [
            {
              name: this.$app.behaviourComponentManager.getBehaviourComponentName(
                this.overTimeChartBehaviourGoal
              ),
              data: _dataLeft,
            },
          ];
          this.seriesOverTimeRight = [
            {
              name: this.$app.behaviourComponentManager.getBehaviourComponentName(
                this.overTimeChartBehaviourGoal
              ),
              data: _dataRight,
            },
          ];
        } else {
          let _data = this.overTimeChartBehaviourGoalsData[
              _overTimeChartBehaviourGoalIndex
              ].filter((data) => {
            if (
                moment(data.x).isSameOrAfter(moment(_fromDate), "day") &&
                moment(data.x).isSameOrBefore(moment(_untilDate), "day")
            ) {
              return data;
            }
          });
          // Add from and until date for full graph
            _data.unshift({
              x: moment(_fromDate).valueOf(),
              y: null,
            });
            _data.push({
              x: moment(_untilDate).valueOf(),
              y: null,
            });

          // set tickAmount in order to avoid identical labels in given period
          if (daysDifferance < _data.length) {
            this.overTimeChartXAxisTickAmount = daysDifferance < 1 ? daysDifferance + 1 : daysDifferance
          }

          this.seriesOverTime = [
            {
              name: this.$app.behaviourComponentManager.getBehaviourComponentName(
                this.overTimeChartBehaviourGoal
              ),
              data: _data,
            },
          ];
        }

        // New annotations object to be filled
        let _annotations = {
          position: 'back',
          xaxis: [],
        };

        // Only get current selected behaviourComponent LOG changes
        if (this.myBehaviourComponentLogs) {
          let _currentBehaviourGoalLOGChanges =
              this.myBehaviourComponentLogs.filter((changeLOG) => {
                return changeLOG.component.key == this.overTimeChartBehaviourGoal;
              });

          _currentBehaviourGoalLOGChanges.map((LOGChange, index) => {
            let _guidance_level = LOGChange.newLevel;

            let _x = moment(LOGChange.createdAt).isBefore(moment(this.fromDate))
              ? moment(this.fromDate).valueOf()
              : moment(LOGChange.createdAt).valueOf();
            // If not last change set x2 to begin other change, otherwise - today
            let _x2 = index === _currentBehaviourGoalLOGChanges.length - 1
              ? moment().valueOf()
              : moment(_currentBehaviourGoalLOGChanges[index + 1].createdAt).valueOf()

            // If LOG 0 is 1st - set x as the beginning of the enrollment / chart
            if (index === 0 && parseInt(_guidance_level) === 0 &&
              moment(_x2).isAfter(moment(this.fromDate))
            ) {
              _x = moment(this.visit1Date).isBefore(moment(this.fromDate))
                ? moment(this.fromDate).valueOf()
                : moment(this.visit1Date).valueOf()
            }

            const isMedication = this.overTimeChartBehaviourGoal === 'MEDICATIONS'
            const color = parseInt(_guidance_level) === 0 || !isMedication
              ? this.timelineColors[parseInt(_guidance_level)]
              : this.timelineColors[parseInt(_guidance_level) + 1]

            _annotations.xaxis.push({
              label: {
                text: _guidance_level.toString(),
                ..._labelStyle,
              },
              x: _x,
              x2: _x2,
              fillColor: color,
              borderColor: color,
              opacity: 0.6
            });
          });
        }
        // Set annotations (will be copied in computed)
        this.annotationsOverTime = _annotations;
      }
    },

    setOverTimeChartDataFromTimeLineData(index) {
      this.showOverTime = true;
      let _dataObject = this.series[0].data[index];
      this.overTimeChartBehaviourGoal = _dataObject.x;
      this.fromDate = moment(_dataObject.y[0]).format("YYYY-MM-DD");
      this.untilDate = moment(_dataObject.y[1]).format("YYYY-MM-DD");
    },

    setOverTimeChartDataFromTimeLineBehaviourComponent(behaviourComponent) {
      this.showOverTime = true;
      this.overTimeChartBehaviourGoal = behaviourComponent;
      // from the start of the study till today
      this.fromDate = this.visit1Date.clone().format("YYYY-MM-DD");
      this.untilDate = moment().format("YYYY-MM-DD")
    },

    setOverTimeChartDateFromJourney(behaviourComponent) {
      this.showOverTime = true;
      this.overTimeChartBehaviourGoal = behaviourComponent;
      // from the last SDM encounter till today
      this.fromDate = this.moment(this.lastCompletedSDMEncounterDate).format("YYYY-MM-DD");
      this.untilDate = moment().format("YYYY-MM-DD")
    },

    setAnnotationsSDMEncounters() {
      let _labelStyle = {
        position: "top",
        orientation: "horizontal",
        offsetY: -15,
        strokeDashArray: 0,
        borderWidth: 1,
        opacity: 1,
        style: {
          borderColor: "blue",
          fontSize: "0.75rem",
          color: "black",
          fontWeight: 400,
        },
      };

      let _annotations = [];
      if (this.encounters.length > 0) {
        this.encounters.map((encounter, index) => {
          if (encounter.encounterDate) {
            _annotations.push({
              strokeDashArray: 5,
              label: {
                text:
                    index === 0
                        ? `${moment(encounter.encounterDate).format('DD/MM')} ${this.$t("journeyProgress.enrolment")}`
                        : `${moment(encounter.encounterDate).format('DD/MM')} ${this.$t("journeyProgress.sdm")} ${encounter.version - 1}`,
                ..._labelStyle,
                borderColor: this.isSDM && this.currentVersion == index + 1 ? "red" : "#111",
              },
              x: moment(encounter.encounterDate).valueOf(),
              fillColor: this.timelineColors[parseInt(1)],
            });
          }
        });
      }
      return _annotations;
    },

    onSliderClick() {
      if (!this.isSliderAvailable) {
        this.$toasted.show(
          this.$ucfirst(this.$t('journeyProgress.sliderNotAvailable'))
        )
      }
    },
    setAnnotationTooltip(event) {
      const isAnnotationLabel = event.target.classList.contains('apexcharts-xaxis-annotation-label');
      const isAnnotationLabelContainer =
        event.target.tagName === 'rect' &&
        event.target?.nextSibling?.classList.contains('apexcharts-xaxis-annotation-label');
      const isAnnotationLine =
        event.target.tagName === 'line' &&
        event.target?.nextSibling?.nextSibling?.classList.contains('apexcharts-xaxis-annotation-label')

      let text = '';
      // check if target element is annotation
      if (isAnnotationLabel || isAnnotationLabelContainer || isAnnotationLine) {
        if (isAnnotationLabel) {
          text = event.target.innerHTML;
        } else if (isAnnotationLabelContainer) {
          text = event.target.nextSibling.innerHTML;
        } else if (isAnnotationLine) {
          text = event.target.nextSibling.nextSibling.innerHTML;
        }
        // set tooltip coordinates and text
        this.labelTooltipX = event.clientX;
        this.labelTooltipY = event.clientY;
        this.labelTooltipText = text;
        this.showLabelTooltip = text ? true : false
      } else {
        this.showLabelTooltip = false
      }
    },

    setChartOverTimeLabelTooltip(event, right) {
      const parent = event.target.parentNode;
      const labels = parent.parentNode.children;
      // if mouse is on the y axis labels
      if (parent.classList.contains('apexcharts-yaxis-label')) {
        // get index of label
        const index = [...labels].reverse().findIndex(label => label.id === parent.id);
        const fullLabel = this.formatLabelOverTime(index, right);

        if (index >= 0 && fullLabel) {
          this.labelTooltipX = event.clientX;
          this.labelTooltipY = event.clientY;
          this.labelTooltipText = fullLabel;
          this.showLabelTooltip = true;
        }
      } else {
        this.showLabelTooltip = false
      }
    }
  },
};
</script>

<style lang="scss">
@import "../../../../../scss/colors";

.progress-status-journey {
  .inactive {
    cursor: not-allowed;
  }
}

.your-journey__item {
  display: flex;
  justify-content: center;
  position: relative;
}

.your-journey__item-line {
  position: absolute;
  height: 100%;
  top: 0;
}

.c-timeline__icon {
  background-color: map-get($coroColors, lightgray2);
}

.v-patient-overview-medication-prescription__current-prescription {
  font-weight: 500;
  font-family: Futura;
  color: map-get($coroColors, gray);
}

.c-timeline__legend {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  & p {
    font-size: 0.85rem;
  }
}

.c-timeline__legend-small {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  & p {
    font-size: 0.75rem;
  }
}

.c-timeline__legend-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.progress-status-journey__slider-label {
  font-size: 0.9rem;
}

.c-timeline__apexchart .apexcharts-svg {
  overflow: visible;
}

.c-timeline__apexchart .apexcharts-tooltip-rangebar {
  font-size: 0.85rem;
}

.progress-status-journey__label-tooltip {
  border: 1px solid #e3e3e3;
  background: rgba(255, 255, 255, 0.96);
  font-size: 14px;
  box-shadow: 2px 2px 6px -4px #999;
  color: rgba(0, 0, 0, 0.87);
  opacity: 1 !important;
}

</style>
